import React from "react";
import { colorFillScale, domain } from "../utils/scale";

// Convert colorScale into legend items and format text where needed.
const items = domain.map(item => {
  let title;
  if (item.toLowerCase() === "yes - partial") {
    title = "Yes (partial)";
  } else if (item.toLowerCase() === "yes") {
    title = "Yes (full)";
  } else {
    title = item;
  }
  return {
    title,
    color: colorFillScale(item),
  };
});

const Legend = () => (
  <div className="legend__container">
    <div className="legend__container-inner">
      {items.map((item, i) => (
        <div className={"legend__container-item"} key={item.title}>
          <div
            className={"legend__swatch"}
            style={{ backgroundColor: item.color }}
          />
          <div>{item.title}</div>
        </div>
      ))}
    </div>
  </div>
);

export default Legend;
